import { render, staticRenderFns } from "./ItemStatistics.vue?vue&type=template&id=5600e1a2&"
import script from "./ItemStatistics.vue?vue&type=script&lang=js&"
export * from "./ItemStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports